export const thousandSeparatorPositionRegex = /\B(?=(\d{3})+(?!\d))/g;
export const removedHtmlTagRegex = /(<([^>]+)>)/ig;